export const TOOLTIP_CONTENT = {
  false: `Enable this setting to customize your Sample size, AQL, and Defectives Accepted.`,
  true: `If you turn off this setting, you can only edit your simple size . AQL & 
Defectives Accepted will be based on simple size. `
};
